import React, { useState } from 'react'
import 'react-toastify/dist/ReactToastify.css';
import HouseHold from './household/HouseHold';
import AccountList from './accounts/AccountList';
import Review from './review/Review';
import RiskQuestionnaire from './RiskQuestionnaire';
import RWMAgreement from './RWMAgreement';
import ThankYouPage from './ThankYouPage';
// import ClientGroupList from './client-group/ClientGroupList';
// import axiosInstance from 'custom-axios';

const ChildStep = ({
    userId,
    activeParentStep,
    setActiveParentStep,
    activeChildStep,
    setActiveChildStep,
    setParentErrorStepIndex,
    parentErrorStepIndex
}) => {

    let loginId = localStorage.getItem('login_id');

    const [formAccountData, setFormAccountData] = useState({
        intended_use_of_account: [],
        login_id: loginId,
        beneficiary_details: {
            elect_account_beneficiary: '',
            elect_contingent_beneficiary: '',

            elect_account_beneficiary_details: [
                { id: 0, bene_first_name: "", bene_last_name: "", bene_middle_name: "", bene_sin: '', bene_dob: '', bene_allocation: '', bene_relation: '' }
            ],

            elect_contingent_beneficiary_details: [
                { id: 0, bene_first_name: "", bene_last_name: "", bene_middle_name: "", bene_sin: '', bene_dob: '', bene_allocation: '', bene_relation: '' }
            ]
        },

        bank_information: [{
            bank_name: '',
            bank_currency: '',
            bank_transit_number: '',
            bank_institution_number: '',
            bank_account_number: '',
        }],
        transfer_details: [{
            id: '',
            irrevocable_information: '',
            country: '',
            street_number: '',
            street_name: '',
            street_type: '',
            city: '',
            province: '',
            postal_code: '',
            business_phone: '',
            extension: '',
            dealer_number: '',
            institution_contact: '',
            non_register_account_type: [],
            register_account_type: [],
            transfer_instructions: [
                { instruction_currency: "", institution_account_number: "", institution_transfer_type: "", ti_file: '', user_account_file: [] }
            ]
        }],

        pac_details: [{
            pac_id: '',
            pac_frequency: '',
            pac_account_option: '',
            pac_start_date: '',
            pac_account_number: '',
            pac_bank_name: '',
            pac_transit_number: '',
            pac_institution_number: '',
            plan_investment_instruction: [{
                id: '',
                pii_contribution_type: '',
                pii_fund_number: '',
                pii_fund_name: '',
                pii_gross_amount: ''
            }],
        }],

        swp_details: [{
            swp_id: '',
            swp_frequency: '',
            swp_account_option: '',
            swp_start_date: '',
            swp_account_number: '',
            swp_bank_name: '',
            swp_transit_number: '',
            swp_institution_number: '',
            swp_plan_investment_instruction: [{
                id: '',
                swp_pii_contribution_type: '',
                swp_pii_fund_number: '',
                swp_pii_fund_name: '',
                swp_pii_gross_amount: ''
            }],
        }],
        income_sweep_details: [{
            income_sweep_id: '',
            income_sweep_frequency: '',
            income_sweep_account_option: '',
            income_sweep_start_date: '',
            income_sweep_account_number: '',
            income_sweep_bank_name: '',
            income_sweep_transit_number: '',
            income_sweep_institution_number: '',

            income_sweep_plan_investment_instruction: [{
                id: '',
                income_sweep_pii_contribution_type: '',
                income_sweep_pii_fund_number: '',
                income_sweep_pii_fund_name: '',
                income_sweep_pii_gross_amount: ''
            }],
        }],
    });


    const storedPermissions = localStorage.getItem('manager_permissions');

    const parsedPermissions = storedPermissions
        ? JSON.parse(storedPermissions)
        : {};

    const hasPermission = (permissionName) => {
        return Object.prototype.hasOwnProperty.call(
            parsedPermissions,
            permissionName
        );
    };

    const parentSteps = [
        {
            label: 'Household',
            permissions: ['Household Role', 'Personal Information', 'Address', 'Financial', 'Regulatory'],
            component: 'household'
        },
        {
            label: 'Accounts',
            permissions: ['Account Type & Information', 'Beneficiary Information', 'Transfer Details', 'Bank Information', 'EFT Details', 'PAC Details', 'SWP Details', 'Income Sweep'],
            component: 'accounts'
        },
        {
            label: 'Risk Questionnaire',
            permission: null,
            component: 'risk-questionnaire'
        },
        {
            label: 'Review',
            permission: 'Review',
            component: 'review'
        },
        {
            label: 'Agreement',
            permission: 'Agreement',
            component: 'agreement'
        },
        {
            label: 'Thank You',
            permission: 'Thank You',
            component: 'thank-you'
        }
    ];

    const visibleParentSteps = parentSteps.filter(step => {
        if (step.permission) {
            return hasPermission(step.permission);
        }

        return step.permissions ? step.permissions.some(permission => hasPermission(permission)) : true;
    });




    /* function getParentSteps(activeStep) {
        switch (activeStep) {
            case 0: return <HouseHold parentErrorStepIndex={parentErrorStepIndex} setParentErrorStepIndex={setParentErrorStepIndex} setActiveParentStep={setActiveParentStep} activeParentStep={activeParentStep} setActiveChildStep={setActiveChildStep} activeChildStep={activeChildStep} />
            case 1: return <AccountList parentErrorStepIndex={parentErrorStepIndex} setParentErrorStepIndex={setParentErrorStepIndex} setActiveParentStep={setActiveParentStep} activeParentStep={activeParentStep} setActiveChildStep={setActiveChildStep} activeChildStep={activeChildStep} setFormAccountData={setFormAccountData} formAccountData={formAccountData} />
            // case 2: return <ClientGroupList setActiveParentStep={setActiveParentStep} activeParentStep={activeParentStep} setClientGroupData={setClientGroupData} clientGroupData={clientGroupData} />
            case 2: return <RiskQuestionnaire setActiveChildStep={setActiveChildStep} activeChildStep={activeChildStep} setActiveParentStep={setActiveParentStep} activeParentStep={activeParentStep} />
            case 3: return <Review setActiveChildStep={setActiveChildStep} activeChildStep={activeChildStep} setActiveParentStep={setActiveParentStep} activeParentStep={activeParentStep} />
            case 4: return <RWMAgreement setActiveParentStep={setActiveParentStep} activeParentStep={activeParentStep} />
            case 5: return <ThankYouPage setActiveParentStep={setActiveParentStep} activeParentStep={activeParentStep} />
            default: break;
        }
    } */

    const getParentSteps = (activeStep) => {

        const currentStep = visibleParentSteps[activeStep];

        if (!currentStep) {
            return null;
        }

        switch (currentStep.component) {

            case 'household':
                return (
                    <HouseHold
                        parentErrorStepIndex={parentErrorStepIndex}
                        setParentErrorStepIndex={setParentErrorStepIndex}
                        setActiveParentStep={setActiveParentStep}
                        activeParentStep={activeParentStep}
                        setActiveChildStep={setActiveChildStep}
                        activeChildStep={activeChildStep}
                    />
                );

            case 'accounts':
                return (
                    <AccountList
                        parentErrorStepIndex={parentErrorStepIndex}
                        setParentErrorStepIndex={setParentErrorStepIndex}
                        setActiveParentStep={setActiveParentStep}
                        activeParentStep={activeParentStep}
                        setActiveChildStep={setActiveChildStep}
                        activeChildStep={activeChildStep}
                        setFormAccountData={setFormAccountData}
                        formAccountData={formAccountData}
                    />
                );

            case 'risk-questionnaire':
                return (
                    <RiskQuestionnaire
                        setActiveChildStep={setActiveChildStep}
                        activeChildStep={activeChildStep}
                        setActiveParentStep={setActiveParentStep}
                        activeParentStep={activeParentStep}
                    />
                );

            case 'review':
                return (
                    <Review
                        setActiveChildStep={setActiveChildStep}
                        activeChildStep={activeChildStep}
                        setActiveParentStep={setActiveParentStep}
                        activeParentStep={activeParentStep}
                    />
                );

            case 'agreement':
                return (
                    <RWMAgreement
                        setActiveParentStep={setActiveParentStep}
                        activeParentStep={activeParentStep}
                    />
                );

            case 'thank-you':
                return (
                    <ThankYouPage
                        setActiveParentStep={setActiveParentStep}
                        activeParentStep={activeParentStep}
                    />
                );

            default:
                return null;
        }
    };

    return (
        <>
            {getParentSteps(activeParentStep)}
        </>
    );
}

export default ChildStep